import { TripDTO, TripRequestDTO, TripResponseDTO } from '../../models/Trip/TripModel';
import { TripService } from '../../services/TripService';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { ApiError } from '../../models/Api/ApiError';
import { getBaseQueryOptions } from '../baseQueryOptions';

export interface UseTripValuesInterface {
  trip: TripResponseDTO | undefined;
  isLoading: boolean;
  error: ApiError | null;
}

export const useTripQuery: (tripId: string) => UseTripValuesInterface = (tripId: string) => {
  const queryClient = useQueryClient();

  const { isFetching, error, data } = useQuery<TripResponseDTO, ApiError>({
    ...getBaseQueryOptions(false),
    queryKey: ['trip', tripId],
    queryFn: () => TripService.getTrip(<TripRequestDTO>{ id: tripId }),
    initialData: () => {
      return queryClient.getQueryData<TripDTO[]>(['trips'])?.find((x) => x.identification?.id === tripId);
    },
  });

  return {
    trip: data,
    isLoading: isFetching,
    error: error,
  };
};
